import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LinksService {

  private apiUrl = environment.apiBaseUrl + '/api/links/';

  constructor(private http: HttpClient) { }

  getAllLinks(langCode: string): Observable<any> {
    if (langCode === '') {
      return this.http.get(`${this.apiUrl}getAll`);
    }

    return this.http.get(`${this.apiUrl}getAll?langCode=${langCode}`);
  }

  getLinkById(id: number, langCode: string): Observable<any> {
    if (langCode === '') {
      return this.http.get(`${this.apiUrl}getById?id=${id}`);
    }

    return this.http.get(`${this.apiUrl}getById?id=${id}&langCode=${langCode}`);
  }

  create(request: any): Observable<any> {
    const formData = new FormData();

    if (request.image) {
      formData.append('Image', request.image);
    }

    formData.append('Data', JSON.stringify(request.data));

    return this.http.post(`${this.apiUrl}create`, formData);
  }

  update(id: number, request: any): Observable<any> {
    const formData = new FormData();

    if (request.image) {
      formData.append('Image', request.image);
    }

    formData.append('Data', JSON.stringify(request.data));

    return this.http.put(`${this.apiUrl}update?id=${id}`, formData);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}delete?id=${id}`);
  }
}
